import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { SupportComponent } from "./components/support/support.component";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./theme/shared/shared.module";
import { AppComponent } from "./app.component";
import { AdminComponent } from "./theme/layout/admin/admin.component";
import { AuthComponent } from "./theme/layout/auth/auth.component";
import { UserComponent } from "./theme/layout/user/user.component";
import { NavigationComponent } from "./theme/layout/admin/navigation/navigation.component";
import { NavContentComponent } from "./theme/layout/admin/navigation/nav-content/nav-content.component";
import { NavGroupComponent } from "./theme/layout/admin/navigation/nav-content/nav-group/nav-group.component";
import { NavCollapseComponent } from "./theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component";
import { NavItemComponent } from "./theme/layout/admin/navigation/nav-content/nav-item/nav-item.component";
import { NavBarComponent } from "./theme/layout/admin/nav-bar/nav-bar.component";
import { NavLeftComponent } from "./theme/layout/admin/nav-bar/nav-left/nav-left.component";
import { NavSearchComponent } from "./theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component";
import { NavRightComponent } from "./theme/layout/admin/nav-bar/nav-right/nav-right.component";
import { ConfigurationComponent } from "./theme/layout/admin/configuration/configuration.component";
import { UserNavigationComponent } from "./theme/layout/user/navigation/navigation.component";
import { UserNavContentComponent } from "./theme/layout/user/navigation/nav-content/nav-content.component";
import { UserNavGroupComponent } from "./theme/layout/user/navigation/nav-content/nav-group/nav-group.component";
import { UserNavCollapseComponent } from "./theme/layout/user/navigation/nav-content/nav-collapse/nav-collapse.component";
import { UserNavItemComponent } from "./theme/layout/user/navigation/nav-content/nav-item/nav-item.component";
import { UserNavBarComponent } from "./theme/layout/user/nav-bar/nav-bar.component";
import { UserNavLeftComponent } from "./theme/layout/user/nav-bar/nav-left/nav-left.component";
import { UserNavSearchComponent } from "./theme/layout/user/nav-bar/nav-left/nav-search/nav-search.component";
import { UserNavRightComponent } from "./theme/layout/user/nav-bar/nav-right/nav-right.component";
import { UserConfigurationComponent } from "./theme/layout/user/configuration/configuration.component";
import { ToggleFullScreenDirective } from "./theme/shared/full-screen/toggle-full-screen";
import { NavigationService } from "./theme/layout/admin/navigation/navigation";
import { NgbButtonsModule, NgbDropdownModule, NgbTabsetModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { QuillModule } from "ngx-quill";
import { NgxStripeModule } from "ngx-stripe";
import { TermsOfUsePageComponent } from "./terms-of-use-page/terms-of-use-page.component";
import { NgxPaginationModule } from "ngx-pagination";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { SelectModule } from "ng-select";
import { KeyMetricsModule } from "./components/key-metrics/key-metrics.module";
import { PrivacyPolicyPageComponent } from './privacy-policy-page/privacy-policy-page.component';
import { EcgReportRoutingModule } from './components/radiology/ecg-report/ecg-report-routing.module';
import { CurrencyService } from "./others/services/currency.service";
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { TableDateModule } from "./table-date/table-date.module";
import { environment } from "src/environments/environment";
import { AuthInterceptor } from "./others/interceptors/auth.interceptor";


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    UserComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ConfigurationComponent,
    UserNavigationComponent,
    UserNavContentComponent,
    UserNavGroupComponent,
    UserNavCollapseComponent,
    UserNavItemComponent,
    UserNavBarComponent,
    UserNavLeftComponent,
    UserNavSearchComponent,
    UserNavRightComponent,
    UserConfigurationComponent,
    ToggleFullScreenDirective,
    SupportComponent,
    TermsOfUsePageComponent,
    PrivacyPolicyPageComponent,
    // Base64ImagePipe,
    // KeyMetricsComponent,
    // TatComponent,
    // StaffCollectionComponent,
    // DiscountsComponent,
    // ReceivablesComponent,
    // PerformanceComponent,
    // ClientReportsComponent,
    // UTObstetricsComponent,
    // TesticularBiopsyComponent,
    // RequestingFacilityFormComponent,
    // RequestingDoctorFormComponent,
    // SubscriptionComponent,
    // FacilityProfileComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    PerfectScrollbarModule,
    NgxStripeModule.forRoot(environment.stripeKey),
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    HttpClientModule,
    QuillModule.forRoot(),
    // CKEditorModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    SelectModule,
    KeyMetricsModule,
    EcgReportRoutingModule,
    NgxIntlTelInputModule,
    GooglePlaceModule,
    TableDateModule

  ],
  providers: [
    NavigationService,
    CurrencyService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  // exports:[Base64ImagePipe]
})
export class AppModule {
}
